<div *ngIf="!!informationMessage" [attr.test-id]="testId" [innerHtml]="informationMessage"></div>
